import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import { Copyright } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { TestBem } from '../../service/TestBem';
import { UrlHelpers } from '../../service/UrlHelpers';
import { Tld } from '../../typings/common';
import { StyledLink, StyledLinkTheme } from '../StyledLink/StyledLink';

import './Footer.css';
import * as keyset from './Footer.i18n';

const i18n = i18nFactory(keyset);

export enum FooterLinkId {
    advertisement = 'advertisement',
    selfAgencyHelpLink = 'selfAgencyHelpLink',
    agencyClientHelpLink = 'agencyClientHelpLink',
    commonHelpLink = 'agencyClientHelpLink'
}

export interface FooterProps {
    cls?: string;
    tld: Tld;
    copyrightStart: number;
    links: Array<FooterLinkId>;
}

const blockClass = 'dna-footer';

export class Footer extends React.PureComponent<FooterProps, {}> {
    render() {
        const { cls, copyrightStart } = this.props;

        return (
            <div className={classNames(blockClass, cls)}>
                {this.getLinks()}

                <Copyright
                    cls={classNames(
                        Bem.cls(blockClass, 'copy'),
                        TestBem.cls(blockClass, 'copy')
                    )}
                    start={copyrightStart}
                />
            </div>
        );
    }

    private getLinks = () => {
        const { links, tld } = this.props;
        const linksData: Record<FooterLinkId, { url: string; text: string }> = {
            [FooterLinkId.advertisement]: {
                url: UrlHelpers.getAdvUrl('', tld),
                text: i18n('advertisement')
            },
            [FooterLinkId.selfAgencyHelpLink]: {
                url: UrlHelpers.getCommonHelpUrl(
                    'direct/troubleshooting/start.html',
                    tld
                ),
                text: i18n('self-agency-help-link')
            },
            [FooterLinkId.agencyClientHelpLink]: {
                url: UrlHelpers.getCommonHelpUrl(
                    'direct/troubleshooting/start.html',
                    tld
                ),
                text: i18n('agency-client-help-link')
            },
            [FooterLinkId.commonHelpLink]: {
                url: UrlHelpers.getCommonHelpUrl(
                    'direct/troubleshooting/start.html',
                    tld
                ),
                text: i18n('common-help-link')
            }
        };

        if (links.length === 0) {
            return null;
        }

        return (
            <ul className={Bem.cls(blockClass, 'links')}>
                {links.map(linkId => {
                    const { url, text } = linksData[linkId];

                    return (
                        <li
                            key={linkId}
                            className={Bem.cls(blockClass, 'links-item')}
                        >
                            <StyledLink href={url} theme={StyledLinkTheme.grey}>
                                {text}
                            </StyledLink>
                        </li>
                    );
                })}
            </ul>
        );
    };
}
